/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export type { Logger } from './types/Logger';
export type { LoggerProvider } from './types/LoggerProvider';
export { SeverityNumber } from './types/LogRecord';
export type { LogAttributes, LogBody, LogRecord } from './types/LogRecord';
export type { LoggerOptions } from './types/LoggerOptions';
export type { AnyValue, AnyValueMap } from './types/AnyValue';
export { createNoopLogger } from './NoopLogger';

import { LogsAPI } from './api/logs';
export const logs = LogsAPI.getInstance();
